export type StatusOption = {
  id: string;
  label: string;
  dotColor: string;
};

export const UTILITY_BILL_STATUS_OPTIONS: StatusOption[] = [
  {
    id: "Emissions Included (User Confirmed)",
    label: "Emissions Included",
    dotColor: "rgb(158, 231, 102)",
  },
  {
    id: "Not Applicable (Cost Only)",
    label: "Not Applicable (Cost Only)",
    dotColor: "rgb(127, 127, 127)",
  },
  {
    id: "Not Applicable (Invalid Data)",
    label: "Not Applicable (Invalid Data)",
    dotColor: "rgb(127, 127, 127)",
  },
  {
    id: "Reviewed",
    label: "Reviewed",
    dotColor: "rgb(0, 161, 255)",
  },
];
